<template>
  <q-form ref="editForm">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-card title="안전보건팀 패트롤 기본정보" class="cardClassDetailInfo">
        <template slot="card-button">
          <q-btn-group outline>
            <!-- <c-btn 
              v-if="editable&&!disabled"
              :isSubmit="isComplete"
              :url="completeUrl"
              :param="standardInfo"
              :mappingType="completeType"
              label="완료" 
              icon="check"
              @beforeAction="completeCto"
              @btnCallback="completeCallback" />
            <c-btn label="삭제" v-if="editable&&!disabled" icon="delete_forever" @btnClicked="remove" /> -->
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-3">
            <c-label-text title="패트롤명" :value="standardInfo.mdmSopId"></c-label-text>
          </div>
          <!-- <div class="col-3">
            <c-label-text title="작업구역" :value="standardInfo.workArea"></c-label-text>
          </div> -->
          <div class="col-3">
            <c-label-text title="패드롤일" :value="standardInfo.ctoDate"></c-label-text>
          </div>
          <div class="col-3">
            <c-label-text title="패트롤자" :value="standardInfo.observeUserName"></c-label-text>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="tableImpr"
        title="개선 목록"
        :columns="gridImpr.columns"
        :data="ctoInfo.ctoImproveModelList"
        :merge="gridImpr.merge"
        selection="multiple"
        rowKey="causesNo"
        :gridHeight="gridImpr.height"
        :usePaging="false"
        :filtering="false"
        :columnSetting="false"
        :editable="editable && !disabled"
      >
        <template slot="table-chip">
          <font color="red">안전보건팀 패트롤의 개선요청은 체크리스트 항목별로 요청이 가능합니다.(현재화면-기존 데이터 조회용)</font>
        </template>
        <template slot="table-button">
          <q-btn-group outline >
            <!-- <c-btn v-if="editable && !disabled && ctoInfo.ctoImproveModelList.length > 0" label="삭제" :showLoading="false" icon="remove" @btnClicked="removeImpr" />
            <c-btn v-if="editable && !disabled" label="추가" :showLoading="false"  icon="add" @btnClicked="add" /><c-btn
              v-if="!disabled && ctoInfo.ctoImproveModelList.length > 0"
              :url="updateUrl"
              :isSubmit="isSave"
              :param="ctoInfo.ctoImproveModelList"
              mappingType="POST"
              label="저장"
              icon="save"
              @beforeAction="saveImprove"
              @btnCallback="saveCallback" 
            /> -->
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames'] && col.name === 'customCol'">
            <q-chip
              v-for="(item, index) in $comm.ibmTagItems(props.row, colorItems)"
              :key="index"
              :color="item.color"
              :clickable="true"
              text-color="white"
              style="margin-bottom:4px !important;"
              @click="linkClick(item, props.row)">
              {{item.title}}
              <c-assess-tooltip 
                :ibmTooltip="item.ibmTooltip"
                :ibmClassCd="item.ibmClassCd"
              />
            </q-chip>
          </template>
          <!-- <div v-if="props.row.editFlag!=='C'">
            <q-btn-group outline class="ColumInnerBtnGroup">
              <q-btn
                v-if="editable&&!disabled"
                icon="add"
                color="red-6"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '1')">
                <q-tooltip>
                  개선요청등록
                </q-tooltip>
              </q-btn>
              <q-btn
                v-if="editable&&!disabled"
                icon="add"
                color="light-blue"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '2')">
                <q-tooltip>
                  즉시조치등록
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </div> -->
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'cto-cause-prevention',
  props: {
    tabParam: {
      type: Object,
      default: () => ({
        sopCtoId: '',
        ctoCompleteFlag: '',
        ctoChecklistModels: [],
      }),
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      editable: true,
      standardInfo: {
        sopName: '',
        processName: '',
        ctoDate: '',
        observeUserName: '',
        ctoCompleteFlag: 'N',
      },
      ctoInfo: {
        ctoImproveModelList: [],
      },
      gridImpr: {
        columns: [
          {
            required: true,
            name: 'locationDetail',
            field: 'locationDetail',
            label: '세부위치',
            align: 'left',
            type: 'text',
            style: 'width:25%',
            sortable: false,
          },
          {
            required: true,
            name: 'findings',
            field: 'findings',
            label: '발견사항',
            align: 'left',
            type: 'text',
            style: 'width:25%',
            sortable: false,
          },
          {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:20%',
                type: 'custom',
                sortable: false
              },
              {
                name: 'improveMeasures',
                field: 'improveMeasures',
                label: '개선대책',
                align: 'left',
                style: 'width:40%',
                type: 'text',
                sortable: false
              },
            ]
          },
        ],
        
        data: [],
        height: '650px'
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        popupParam: {},
        closeCallback: null,
      },
      colorItems: [],
      requestImprRow: null,
      imprData: null,
      completeType: 'PUT',
      completeUrl: '',
      deleteUrl: '',
      searchUrl: '',
      isComplete: false,
      isSave: false,
      updateUrl: '',
    };
  },
  computed: {
    disabled() {
      return this.editable && Boolean(this.standardInfo.ctoCompleteFlag) && this.standardInfo.ctoCompleteFlag === 'Y'
    }
  },
  watch: {
    'count'() {
      this.getStdInfo();
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });
      this.getUrl = selectConfig.sop.cto.basic.get.url;
      this.getInfoUrl = selectConfig.sop.cto.improve.get.url;
      this.updateUrl = transactionConfig.sop.cto.improve.update.url
      this.deleteUrl = transactionConfig.sop.cto.improve.delete.url
      this.completeUrl = transactionConfig.sop.cto.basic.complete.url

      this.getStdInfo();
      this.getDetail();
    },
    getStdInfo() {
      if (this.tabParam.sopCtoId) {
        this.$http.url = this.$format(this.getUrl, this.tabParam.sopCtoId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.standardInfo = _result.data;

          this.updateMode = true;
        },);
      }
    },
    getDetail() {
      if (this.tabParam.sopCtoId) {
        this.$http.url = this.$format(this.getInfoUrl, this.tabParam.sopCtoId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.ctoInfo.ctoImproveModelList = this.$_.clone(_result.data)
        },);
      }
    },
    /* eslint-disable no-unused-vars */
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row
      let requestContents = props.row.locationDetail;
      if (btn === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.ctoImproveId,
          ibmTaskTypeCd: 'ITT0000060',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.ctoImproveId,
          ibmTaskTypeCd: 'ITT0000060',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.$_.forEach(data, item => {
        let sData = this.requestImprRow.sopImprovementIds ? this.requestImprRow.sopImprovementIds : '';
        if (sData.indexOf(item.sopImprovementId) === -1) {
          this.requestImprRow.sopImprovementIds = this.requestImprRow.sopImprovementIds ? 
            this.requestImprRow.sopImprovementIds + ',' + item.sopImprovementId : item.sopImprovementId
          this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames ? 
            this.requestImprRow.ibmStepNames + ',' + item.ibmStepName : item.ibmStepName
          this.requestImprRow.ibmClassCds = this.requestImprRow.ibmClassCds ? 
            this.requestImprRow.ibmClassCds + ',' + item.ibmClassCd : item.ibmClassCd
          this.requestImprRow.ibmTooltip = this.requestImprRow.ibmTooltip ? 
            this.requestImprRow.ibmTooltip + ',' + item.ibmTooltip : item.ibmTooltip
        }
      })
      if (data && data.length > 0) {
        this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;

      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        this.popupOptions.width = '90%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      }
    },
    closeImprPopup(result, flag) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getDetail();
      this.$refs['tableImpr'].$refs['compo-table'].resetVirtualScroll();
    },
    saveImprove(type) {
      let isConti = true;
      let checkItem = ['locationDetail', 'findings' ]
      this.$_.forEach(this.ctoInfo.ctoImproveModelList, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [세부위치, 발견사항]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.ctoInfo.regUserId = this.$store.getters.user.userId
            this.ctoInfo.chgUserId = this.$store.getters.user.userId
            
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    completeCto() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '완료 하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.standardInfo.regUserId = this.$store.getters.user.userId
          this.standardInfo.chgUserId = this.$store.getters.user.userId
          
          this.isComplete = !this.isComplete;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getStdInfo();
    },
    /* eslint-disable no-unused-vars */ 
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(transactionConfig.sop.iim.accident.near.delete.url, this.ctoInfo.sopCtoId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup', 'REMOVE');  
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    add() {
      this.ctoInfo.ctoImproveModelList.splice(0, 0, {
        sopCtoId: this.tabParam.sopCtoId,
        causesNo: uuidv4(),
        causeTypeCd: null,
        accidentCause: '',
        improvingMeasures: '',
        sopImprovementIds: '', 
        ibmStepNames: '', 
        editFlag: 'C',
      })
    },
    removeImpr() {
      let selectData = this.$refs['tableImpr'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$refs['tableImpr'].$refs['compo-table'].clearSelection();
              this.getDetail();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
